import * as React from "react";

import primaryColour from "../constants";

function SvgLocation(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={10} height={14} viewBox="0 0 10 14" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.71618 0C7.31565 0 9.43236 2.11671 9.43236 4.71618C9.43236 6.61008 7.72414 8.8382 6.75862 10.5093L4.71618 14L2.67374 10.5093C1.70822 8.8382 0 6.61008 0 4.71618C0 2.11671 2.11671 0 4.71618 0ZM4.71618 2.22812C6.09019 2.22812 7.20424 3.34218 7.20424 4.71618C7.20424 6.09019 6.09019 7.20424 4.71618 7.20424C3.34218 7.20424 2.22812 6.09019 2.22812 4.71618C2.22812 3.34218 3.34218 2.22812 4.71618 2.22812Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgLocation;
